import { Facility } from "types/facility.type";
import { useCreateOrUpdateSeparatorLogic } from "../../../hooks/useCreateOrUpdateSeparatorLogic.hook";
import {
  ContentContainer,
  HeaderContainer,
  ShadowCard,
} from "components/ShadowCard";
import { Headline4 } from "components/typography/Headline4";
import { AddSeparatorModal } from "./AddSeparatorModal";
import EmptyState from "components/EmptyState";
import { getSeparatorTypeLabel } from "types/separator/separator.helpers";
import { Headline5 } from "components/typography/Headline5";
import PrimaryButton from "components/buttons/PrimaryButton";
import { useNavigate } from "@tanstack/react-router";
import { Separator } from "types/separator/separator.type";
import { Link } from "components/Link";
import { useHasRightsForFeature } from "api/company.api";
import { OperatorPrivilege } from "types/company.type";

type Props = {
  facility: Facility;
};

export const FacilitySeparatorListTab = ({ facility }: Props) => {
  const navigate = useNavigate();
  const logic = useCreateOrUpdateSeparatorLogic(facility, (s: Separator) => {
    navigate({
      to: "/app/kunder/$customerId/facility/$facilityId/separator/$separatorId",
      params: {
        customerId: s.facility.customer.id.toString(),
        facilityId: s.facility.id.toString(),
        separatorId: s.id.toString(),
      },
    });
  });

  const hasRightToAddSeparator = useHasRightsForFeature(
    OperatorPrivilege.AddSeparator,
  );

  const noSeparators = facility.separatorList.length === 0;
  return (
    <ShadowCard className="max-w-5xl">
      <HeaderContainer>
        <Headline4>Objekt</Headline4>
        {facility.separatorList.length > 0 && hasRightToAddSeparator && (
          <PrimaryButton size="small" onClick={logic.openModal}>
            + Nytt objekt
          </PrimaryButton>
        )}
      </HeaderContainer>
      <AddSeparatorModal logic={logic} />
      <ContentContainer>
        {noSeparators ? (
          <EmptyState
            onClick={hasRightToAddSeparator ? logic.openModal : undefined}
            header="Inga objekt"
            subHeader="Skapa avskiljare och andra objekt för att kunna utföra kontroller och tömningar."
            buttonText={hasRightToAddSeparator ? "Nytt objekt" : undefined}
            iconType="separator"
          />
        ) : (
          <div className="flex flex-col space-y-4">
            {facility.separatorList.map((s) => (
              <Link
                key={s.id}
                to="/app/kunder/$customerId/facility/$facilityId/separator/$separatorId"
                params={{
                  customerId: facility.customer.id.toString(),
                  facilityId: facility.id.toString(),
                  separatorId: s.id.toString(),
                }}
                className="flex justify-between rounded-md border border-gray-200 p-4 shadow-md hover:bg-gray-50"
              >
                <div className="flex flex-col space-y-2 text-sm">
                  <Headline5>{s.identifier}</Headline5>
                  <span className="inline-block max-w-[300px] overflow-hidden truncate text-gray-500">
                    {getSeparatorTypeLabel(s)}
                  </span>
                </div>
                {/* Nedan ska bort */}
              </Link>
            ))}
          </div>
        )}
      </ContentContainer>
    </ShadowCard>
  );
};
